'use client';

import { Button, Separator } from '@baseball-near-you/ui';
import { signup } from '@bb/app/sign-up/actions';
import { QueryKey } from '@bb/lib/hooks/QueryKey';
import { useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { useFormStatus } from 'react-dom';
import { LoginWithGoogleButton } from './LoginWithGoogleButton';
import { Messages } from './Messages';

export function SignupForm(props: {
  onLoginClick: () => void;
  onSignupSuccess?: () => void;
}) {
  const searchParams = useSearchParams();
  const message = searchParams?.get('message');
  const queryClient = useQueryClient();

  return message ? (
    <Suspense>
      <Messages />
    </Suspense>
  ) : (
    <>
      <form
        className="flex h-min w-full flex-1 flex-col gap-2 text-foreground"
        action={async (data) => {
          await signup(data);
          queryClient.setQueryData([QueryKey.User], null);
          await queryClient.invalidateQueries([QueryKey.User]);

          props.onSignupSuccess?.();
        }}
      >
        <p className="title text-xl">SIGN UP</p>
        <Suspense>
          <Messages />
        </Suspense>

        <label className="text-md" htmlFor="email">
          Email
        </label>
        <input
          className="mb-6 rounded-md border bg-inherit px-4 py-2"
          name="email"
          placeholder="you@example.com"
          required
        />
        <label className="text-md" htmlFor="password">
          Password
        </label>
        <input
          className="mb-6 rounded-md border bg-inherit px-4 py-2"
          type="password"
          name="password"
          placeholder="••••••••"
          required
        />
        <label className="text-md" htmlFor="confirm-password">
          Confirm password
        </label>
        <input
          className="mb-6 rounded-md border bg-inherit px-4 py-2"
          type="password"
          name="confirm-password"
          placeholder="••••••••"
          required
        />
        <SignInButton />
      </form>
      <Separator className="my-2" />
      <LoginWithGoogleButton />
      <p className="mt-2 text-center text-gray-400 text-xs">
        Already have an account?
      </p>
      <Button
        type="button"
        onClick={props.onLoginClick}
        className="mt-2 w-full rounded border border-gray-700 bg-white py-2 text-black"
        variant="secondary"
      >
        Login
      </Button>
    </>
  );
}

const SignInButton = () => {
  const { pending } = useFormStatus();
  return (
    <Button
      className="mb-2 rounded bg-red py-2 text-white hover:bg-red/90"
      loading={pending}
    >
      Sign up
    </Button>
  );
};
